"use client";

import { Button as ButtonItem, Label } from "semantic-ui-react";

export default function SaveNeighborButton({
  loggedin,
  save,
  isMobile,
  onSaveNeighbor,
}) {
  if (!loggedin) return null;

  return save ? (
    <ButtonItem
      as="div"
      labelPosition="right"
      className="theme_green btn_green"
      onClick={onSaveNeighbor}
      floated="right"
    >
      <ButtonItem icon="check" className="theme_green btn_green" />
      <Label
        as="a"
        content="Saved"
        basic
        className="theme_green btn_green"
        pointing="left"
      />
    </ButtonItem>
  ) : (
    <ButtonItem
      as="div"
      labelPosition="right"
      className="theme_blue btn_blue"
      onClick={onSaveNeighbor}
      floated="right"
    >
      <ButtonItem className="btn_blue_bg" icon="heart" />
      <Label
        as="a"
        name="saveNeighbor"
        content={isMobile ? "Save" : "Save this Neighborhood"}
        basic
        className="theme_blue btn_blue"
        pointing="left"
      />
    </ButtonItem>
  );
}
